// The checkout clears the guest checkout state and empties the cart right
// before it leaves for a hosted payment page. That re-renders the review page
// as signed out with no orders while the browser is still navigating, which
// would open the auth modal, send the user back to the menu, or show the empty
// cart. The flag lets the review page skip all of that during that window.
let redirecting = false

// Set the flag ahead of the redirect when the state change that re-renders the
// review page happens before the redirect itself.
export const markRedirectingToPayment = () => {
  if (redirecting) return
  redirecting = true

  // Going back from the payment page can restore this page from the
  // back/forward cache with the flag still set. Reload it to start over.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload()
  })
}

export const redirectToPayment = (url) => {
  markRedirectingToPayment()
  window.location.href = url
}

export const isRedirectingToPayment = () => redirecting
